import React, { useState, useEffect } from "react";
import axios from "axios";

const NoticeSection = () => {
  const [formData, setFormData] = useState({
    title: "",
    date: "",
    description: "",
    target: "All",
  });

  const [notices, setNotices] = useState([]);

  // 🔥 Fetch latest 15 notices
  const fetchNotices = async () => {
    try {
      const res = await axios.get(
        "https://admin.stipsredu.in/notices/latest"
      );
      setNotices(res.data.data);
    } catch (error) {
      console.error("Error fetching notices", error);
    }
  };

  useEffect(() => {
    fetchNotices();
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(
        "https://admin.stipsredu.in/notices/add",
        formData
      );

      alert("Notice Published Successfully!");

      // Reset form
      setFormData({
        title: "",
        date: "",
        description: "",
        target: "All",
      });

      // 🔥 Refresh list after adding
      fetchNotices();

    } catch (error) {
      console.error(error);
      alert("Error publishing notice");
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">Add Notice</h2>

      {/* FORM */}
      <form
        onSubmit={handleSubmit}
        className="space-y-4 bg-white p-6 rounded-xl shadow-md"
      >
        <input
          type="text"
          name="title"
          value={formData.title}
          onChange={handleChange}
          placeholder="Title"
          className="w-full p-3 border rounded-lg"
          required
        />

        <input
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
          required
        />

        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          placeholder="Description"
          className="w-full p-3 border rounded-lg"
          required
        />

        <select
          name="target"
          value={formData.target}
          onChange={handleChange}
          className="w-full p-3 border rounded-lg"
        >
          <option value="All">All</option>
          <option value="Faculty">Faculty</option>
          <option value="Students">Students</option>
        </select>

        <button
          type="submit"
          className="bg-[#112E65] text-white px-6 py-2 rounded-lg"
        >
          Publish Notice
        </button>
      </form>

      {/* 🔥 DISPLAY NOTICES */}
      <div className="mt-10">
        <h2 className="text-xl font-bold mb-4">Latest Notices</h2>

        {notices.length === 0 ? (
          <p>No notices available.</p>
        ) : (
          <div className="space-y-4">
            {notices.map((notice) => (
              <div
                key={notice._id}
                className="bg-white p-5 rounded-xl shadow-md border"
              >
                <h3 className="text-lg font-semibold text-[#112E65]">
                  {notice.title}
                </h3>

                <p className="text-sm text-gray-500">
                  {new Date(notice.date).toLocaleDateString()} | Target: {notice.target}
                </p>

                <p className="mt-2 text-gray-700">
                  {notice.description}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default NoticeSection;